import type { ComponentChildren } from "preact";

export function EmptyState({ title, description, action }: { title: string; description: string; action?: ComponentChildren }) {
  return (
    <div class="empty-state">
      <p class="empty-state__title">{title}</p>
      <p class="empty-state__description">{description}</p>
      {action}
    </div>
  );
}

export function LoadingState({ label = "Loading…" }: { label?: string }) {
  return (
    <div class="loading-state" role="status" aria-live="polite">
      <span class="spinner" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}

export function ConfirmDialog({
  title,
  message,
  confirmLabel = "Confirm",
  danger = false,
  onConfirm,
  onCancel,
}: {
  title: string;
  message: string;
  confirmLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return (
    <div class="overlay" onClick={onCancel}>
      <div class="modal" style={{ maxWidth: "400px" }} role="alertdialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        <div class="modal__header">
          <h2>{title}</h2>
        </div>
        <div class="modal__body">
          <p>{message}</p>
          <div class="form-actions">
            <button type="button" class="btn btn--secondary" onClick={onCancel}>
              Cancel
            </button>
            <button type="button" class={danger ? "btn btn--danger" : "btn btn--primary"} onClick={onConfirm}>
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
